<template>
  <div>

    <Head title="商品管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <merchandise-template>
      <DataTable :value="$page.props.merchandises.data" :selection.sync="selectedMerchandises" sortMode="multiple"
        :multiSortMeta.sync="multiSortMeta" @sort="onSort($event)"><template #header>
          <div class="flex justify-between items-center">
            <div class="flex flex-row gap-2 items-center" v-if="selectedMerchandises.length > 0">
              <span> 已選擇 {{ selectedMerchandises.length }} 個 </span>
              <span>
                <Dropdown :options="batch_action.options" v-model="batch_action.selected" optionLabel="name"
                  optionValue="code" placeholder="選擇動作…" @change="batchAction" />
              </span>
            </div>
            <div v-else></div>
            <div class="flex flex-row items-center gap-2">
              <MultiSelect class="w-48" v-model="selectedFilters" :options="filterables" optionLabel="label"
                optionValue="condition" placeholder="依條件篩選" @change="onFilter" />
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText class="w-52" v-model="search" placeholder="搜尋商品" @input="onSearch" />
              </span>
            </div>
          </div>
        </template>
        <Column headerClass="w-11" selectionMode="multiple"></Column>
        <Column headerClass="w-14" field="images" header="圖片">
          <template #body="slotProps">
            <template v-if="Array.isArray(slotProps.data.images) &&
              slotProps.data.images.length > 0
              ">
              <div class="
                  w-[50px]
                  h-[50px]
                  bg-fh-gray-light
                  flex
                  items-center
                  justify-center
                  bg-cover bg-center
                " :style="{
                  'background-image':
                    'url(\'/storage/product-images/' +
                    slotProps.data.images[0] +
                    '/50.jpg\')',
                }"></div>
            </template>
            <template v-else>
              <div class="
                  w-[50px]
                  h-[50px]
                  bg-fh-gray-light
                  flex
                  items-center
                  justify-center
                ">
                無
              </div>
            </template>
          </template>
        </Column>
        <Column headerClass="w-36" field="PROD_CD" header="商品編號" sortable></Column>
        <Column headerClass="w-52" field="name" header="商品名稱" sortable>
        </Column>
        <Column headerClass="w-24" field="price" header="價格" sortable>
          <template #body="slotProps">
            {{ slotProps.data.price | commaFormat | priceFormat }}
          </template>
        </Column>
        <Column headerClass="w-24" field="cv" header="CV" sortable>
          <template #body="slotProps">
            {{ slotProps.data.cv | commaFormat }}
          </template>
        </Column>
        <Column headerClass="w-24" field="available" header="商品狀態" sortable>
          <template #body="slotProps">
            <Tag v-if="slotProps.data.deleted_at" class="mr-2" severity="info">
              <template v-if="slotProps.data.duplicated">
                <span v-tooltip="'商品編號已被重複使用'">無法復原</span>
              </template>
              <template v-else>可復原</template>
            </Tag>
            <Tag v-else class="mr-2" :severity="slotProps.data.available == 1 ? 'success' : 'danger'">
              {{ slotProps.data.available == 1 ? "上架中" : "未上架" }}
            </Tag>
          </template>
        </Column>
        <Column headerClass="w-36" header="動作">
          <template #body="slotProps">
            <template v-if="slotProps.data.deleted_at">
              <Button :disabled="slotProps.data.duplicated" @click="restoreMerchandise(slotProps.data)">復原</Button>
            </template>
            <SplitButton v-else label="編輯" :model="slotProps.data.available == 1
                ? splitButonFunction(slotProps.data, 'off')
                : splitButonFunction(slotProps.data, 'on')
              " @click="edit(slotProps.data)"></SplitButton>
          </template>
        </Column>

        <template #empty>沒有任何符合條件的商品。</template>
      </DataTable>
    </merchandise-template>
    <div class="w-full mt-10 flex justify-around">
      <Paginator :page-data="$page.props.merchandises" />
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import MerchandiseTemplate from "./Shared/MerchandiseTemplate";
import DataTable from "primevue/datatable";
import Dropdown from "primevue/dropdown";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import SplitButton from "primevue/splitbutton";
import Tag from "primevue/tag";
import Paginator from "@/Shared/Paginator";

export default {
  components: {
    ScrollTop,
    Breadcrumb,
    MerchandiseTemplate,
    DataTable,
    Dropdown,
    Column,
    Button,
    InputText,
    MultiSelect,
    SplitButton,
    Tag,
    Paginator,
  },
  layout: Layout,
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      breadcrumb_home: {
        label: "商品分類管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "商品管理",
          to: route("admin.merchandise"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      batch_action: {
        options: [
          { name: "上架商品", code: "available_on" },
          { name: "下架商品", code: "available_off" },
        ],
        selected: null,
      },
      filterables: [
        {
          label: "上架中",
          condition: {
            field: "available",
            value: 1,
          },
        },
        {
          label: "未上架",
          condition: {
            field: "available",
            value: 0,
          },
        },
      ],
      selectedFilters: [],
      selectedMerchandises: [],
      multiSortMeta: [],
      search: null,
    };
  },
  methods: {
    getQueryStrings() {
      let queryStr = window.location.search,
        queryArr = queryStr.replace("?", "").split("&"),
        queryParams = [];

      for (let q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        let qArr = queryArr[q].split("=");
        queryParams[qArr[0]] = qArr[1];
      }

      return _(queryParams).omitBy(_.isUndefined).omitBy(_.isNull).value();
    },
    splitButonFunction(item, value) {
      return [
        {
          label: value == "on" ? "上架" : "下架",
          command: () => this.setAvailable(item, value),
        },
        {
          label: "刪除",
          command: () => this.deleteMerchandise(item),
        },
      ];
    },
    batchAction() {
      let code = this.batch_action.selected;
      this.batch_action.selected = null;

      let batch = this.selectedMerchandises.map((selected) => selected.id);
      let action = null;

      this.selectedMerchandises = [];

      switch (code) {
        case "available_on":
          action = "on";
          break;
        case "available_off":
          action = "off";
          break;
      }

      this.$inertia.post(
        route("admin.merchandise.batch_set_available"),
        {
          id: batch,
          action: action,
          from: this.$page.url,
        },
        {
          preserveState: true,
          preserveScroll: true,
        }
      );
    },
    edit(item, back_url = this.$page.url) {
      this.$inertia.visit(route("admin.merchandise.edit", item.id), {
        data: {
          from: btoa(encodeURIComponent(back_url)),
        },
      });
    },
    setAvailable(item, action) {
      this.selectedMerchandises.splice(
        this.selectedMerchandises.indexOf(item, 1)
      );

      this.$inertia.post(
        route("admin.merchandise.batch_set_available"),
        {
          id: [item.id],
          action: action,
          from: this.$page.url,
        },
        {
          preserveState: true,
          preserveScroll: true,
        }
      );
    },
    deleteMerchandise(item) {
      this.$inertia.delete(route("admin.merchandise.delete", item.id));
    },
    restoreMerchandise(item) {
      this.$inertia.post(route("admin.merchandise.batch_restore"), {
        id: [item.id],
      });
    },
    onSearch: _.debounce(function () {
      this.selectedMerchandises = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["search"] = this.search;

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    }, 1000),
    onSort(event) {
      this.selectedMerchandises = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["sort"] = JSON.stringify(event.multiSortMeta);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
    onFilter(event) {
      this.selectedMerchandises = [];

      let queryStringArray = this.getQueryStrings();

      queryStringArray["filter"] = JSON.stringify(event.value);

      let queryStrings = [];

      _.forIn(queryStringArray, (value, key) => {
        queryStrings.push(key + "=" + value);
      });

      let url = this.$page.url.split("?")[0] + "?" + queryStrings.join("&");

      this.$inertia.visit(url, {
        preserveScroll: true,
        preserveState: true,
        only: ["merchandises"],
      });
    },
  },
  mounted() {
    if (this.getQueryStrings()["sort"]) {
      this.multiSortMeta = JSON.parse(
        decodeURI(this.getQueryStrings()["sort"])
      );
    }

    if (this.getQueryStrings()["search"]) {
      this.search = decodeURI(this.getQueryStrings()["search"]);
    }

    if (this.getQueryStrings()["filter"]) {
      let selected = JSON.parse(decodeURI(this.getQueryStrings()["filter"]));

      _.forIn(this.filterables, (item) => {
        let found = _.find(selected, item.condition);
        if (found) {
          this.selectedFilters.push(found);
        }
      });
    }
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
</style>